module.exports = __webpack_public_path__ + "img/login-r-bg.676a6727.jpg";